import { GLOBAL_REFRESH, SET_CUSTOMER_NAME } from "./action";

export const defaultState = {
  customerName: "undefined",
};

function HomeReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_CUSTOMER_NAME:
      return {
        ...state,
        customerName: action.payload,
      };
    case GLOBAL_REFRESH:
      return state;
    default:
      return state;
  }
}

export default HomeReducer;
